module.exports = __webpack_public_path__ + "img/brazil.380428f7.svg";